import { render, staticRenderFns } from "./ExternalImportMenuModal.vue?vue&type=template&id=1b67d73b"
import script from "./ExternalImportMenuModal.vue?vue&type=script&lang=js"
export * from "./ExternalImportMenuModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports